<style scoped lang="stylus">
    .edit-pass {
        height: 100%
        background url(../../assets/images/login-bg.png) no-repeat
        background-size cover
    }
</style>

<template>
    <div class="edit-pass" data-flex="cross:center">
        <div class="con-box login-form">
            <van-cell-group>
                <van-field
                        v-model.trim="form.password"
                        required
                        clearable
                        type="password"
                        label="旧密码"
                        placeholder="请输入旧密码"
                />
                <van-field
                        v-model.trim="form.new_password"
                        required
                        clearable
                        type="password"
                        label="新密码"
                        placeholder="请输入新密码"
                />

                <van-field
                        v-model.trim="re_password"
                        type="password"
                        clearable
                        label="确认密码"
                        placeholder="请重新输入新密码"
                        required
                />
            </van-cell-group>
            <van-button type="primary" size="large" class="submit" @click="submit">提交</van-button>
        </div>

    </div>
</template>

<script>
    import {editPass} from "@/service/user";

    export default {
        props: [],
        components: {},
        data() {
            return {
                form: {
                    password: '',
                    new_password: ''
                },
                re_password: '',
            };
        },
        created() {

        },
        mounted() {

        },
        computed: {},
        watch: {},
        methods: {
            async submit() {
                let pass = this.form.new_password.trim()
                let rePass = this.re_password.trim()
                if (this.form.password == '') {
                    this.$toast('原密码不能为空')
                    return
                }
                if (pass == '') {
                    this.$toast('新密码不能为空')
                    return
                }
                if (pass !== rePass) {
                    this.$toast('两次密码不一致')
                    return
                }

                let res = await editPass(this.form)
                if (res.status) {
                    this.$toast('修改成功')
                } else {
                    this.$toast(res.info)
                }
            }
        },
    };
</script>
